import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { QuoteDetailsCard } from './elements/QuoteDetailsCard'
import { QuoteTimelineStatus } from './elements/QuoteTimelineStatus'
import * as Styled from './styles'

export const QuoteViewSidebar = (): ReactElement => {
  return (
    <Styled.QuoteViewSidebarWrapper>
      <Flex flexDirection="column" gap={Spacing.S16}>
        <QuoteDetailsCard />
        <QuoteTimelineStatus />
      </Flex>
    </Styled.QuoteViewSidebarWrapper>
  )
}
